import { render, staticRenderFns } from "./ProfessionalReviews.vue?vue&type=template&id=1dc1d74d&scoped=true&"
import script from "./ProfessionalReviews.vue?vue&type=script&lang=js&"
export * from "./ProfessionalReviews.vue?vue&type=script&lang=js&"
import style0 from "./ProfessionalReviews.vue?vue&type=style&index=0&id=1dc1d74d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc1d74d",
  null
  
)

export default component.exports